import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export type TradeRequestOverlayAction = 'accept' | 'decline';

export interface TradeRequestDetailOverlayCallbacks {
  onDismiss?: () => void;
  onActionComplete?: (payload: {
    action: TradeRequestOverlayAction;
    requestId: string;
  }) => void;
}

export interface TradeRequestDetailOverlayConfig {
  request: any;
  collectionType: string;
  agentId: string;
  collectionId: string;
  userCollectionId: string;
  userCollectionDetails: any;
  readOnly: boolean;
  listNav?: '' | 'Received' | 'Sent' | 'History';
  callbacks?: TradeRequestDetailOverlayCallbacks;
}

export interface TradeRequestDetailOverlayState {
  isOpen: boolean;
  request: any | null;
  collectionType: string;
  agentId: string;
  collectionId: string;
  userCollectionId: string;
  userCollectionDetails: any | null;
  readOnly: boolean;
  listNav: '' | 'Received' | 'Sent' | 'History';
  callbacks?: TradeRequestDetailOverlayCallbacks;
}

@Injectable({
  providedIn: 'root',
})
export class TradeRequestDetailOverlayService {
  private readonly initialState: TradeRequestDetailOverlayState = {
    isOpen: false,
    request: null,
    collectionType: '',
    agentId: '',
    collectionId: '',
    userCollectionId: '',
    userCollectionDetails: null,
    readOnly: false,
    listNav: '',
    callbacks: undefined,
  };

  private readonly stateSubject =
    new BehaviorSubject<TradeRequestDetailOverlayState>(this.initialState);

  readonly state$: Observable<TradeRequestDetailOverlayState> =
    this.stateSubject.asObservable();

  open(config: TradeRequestDetailOverlayConfig): void {
    const { callbacks, ...rest } = config;
    this.stateSubject.next({
      ...this.initialState,
      ...rest,
      callbacks,
      isOpen: true,
    });
  }

  close(): void {
    this.stateSubject.next({
      ...this.stateSubject.value,
      isOpen: false,
    });
  }

  get isOpen(): boolean {
    return this.stateSubject.value.isOpen;
  }

  get callbacks(): TradeRequestDetailOverlayCallbacks | undefined {
    return this.stateSubject.value.callbacks;
  }

  get currentState(): TradeRequestDetailOverlayState {
    return this.stateSubject.value;
  }
}
